module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("45gYs"))).then(() => parcelRequire('isXaA'));